module.exports = __webpack_public_path__ + "static/media/sidebar-10.e289a2dc.jpeg";